module.exports = __webpack_public_path__ + "img/project_3.41fe9a89.jpg";